import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ProductIntro() {
  return <section className="relative overflow-hidden bg-mp-dark py-16 md:py-24" data-id="element-234" data-mp="1snhgi54oy0yf">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[380px] w-[800px] -translate-x-1/2 opacity-30" style={{
      background: 'radial-gradient(ellipse, rgba(8,117,209,0.35), transparent 65%)'
    }} aria-hidden="true" data-id="element-235" data-mp="2ge4pyuu98yn3" />
      <Container className="relative z-10 text-center" data-id="element-236" data-mp="2bm3gthsdvo1a">
        <SectionTag tone="lime" data-id="element-237" data-mp="2bkio7xpmqf62">Presentamos</SectionTag>
        <h2 className="mx-auto mt-5 max-w-[820px] font-heading text-4xl uppercase leading-tight text-mp-white sm:text-5xl" data-id="element-238" data-mp="2zb5xonf71cuq">
          Maestro en Pista
        </h2>
        <p className="mt-3 font-heading text-sm uppercase tracking-[0.15em] text-mp-electric md:text-base" data-id="element-239" data-mp="344h78wbe47qc">
          El sistema operativo del monitor de pádel
        </p>

        <p className="mx-auto mt-6 max-w-[650px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-240" data-mp="pi5bzv4akbqp">
          Un sistema digital de consulta y planificación que convierte lo que ya sabes de pádel en una metodología
          clara, organizada en 5 tomos.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} className="relative mx-auto mt-10 max-w-[440px]" data-id="element-241" data-mp="1d5dgwbxt5is7">
          <img src={FULL_MOCKUP_URL} alt="Sistema completo Maestro en Pista con los 5 tomos y bonos" width={700} height={700} loading="lazy" className="mx-auto w-full drop-shadow-2xl" data-id="element-242" data-mp="1i5j33clb6d2w" />
        </motion.div>

        <p className="mt-8 font-heading text-xs uppercase tracking-[0.18em] text-mp-gray md:text-sm" data-id="element-243" data-mp="dfdu62qrl1bf">
          5 Tomos · 250+ Páginas · 5 Bonos · Acceso Inmediato
        </p>

        <CTAButton href="#tomos" variant="secondary" size="md" className="mt-6" fullWidthMobile={false} data-id="element-244" data-mp="hj20yj7knsvm">
          Ver los 5 tomos ↓
        </CTAButton>
      </Container>
    </section>;
}